<template>
  <main class="page">
    <slot />
  </main>
</template>

<script setup>
const props = defineProps({
  // footer: { type: Boolean, default: true },
  // footerAlt: { type: Boolean, default: false },
});
</script>

<style lang="scss" scoped>
.page {
  // #app.is-transitioning & {
  //   overflow: hidden;
  // }
}

.page__inner {
  min-height: var(--height);
}
</style>
